import { render, staticRenderFns } from "./import.vue?vue&type=template&id=5d22051a"
import script from "./import.vue?vue&type=script&lang=js"
export * from "./import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports